module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_second-prize.a16ee74c.png";